import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import constants from '../../../../constants';
import RectificationRegisterView from './RectificationRegisterView';
import { Creators as RectificationsActions } from '@/domain/useCases/procedures/rectificationNotes/getEvaluationsToBeCorrected';
import { Creators as procedureActions } from '../../../../../../../domain/useCases/procedures/getProcedureInformation';
import { Creators as RegisterRectificationOfGrade } from '@/domain/useCases/procedures/rectificationNotes/RegisterRectificationOfGrade';
import useExternalSettings from '@/presentation/hooks/useExternalSettings';
import { convertFileToBase64 } from '@/presentation/reusables/Upload/helpers';

interface Request {
  url: string;
  procedureId: number;
}

const RectificationRegisterViewController = () => {
  const dispatch = useDispatch();

  const history = useHistory();
  const params: any = useParams();
  const [openBack, setOpenBack] = useState(false);
  const [selectCourse, setSelectCourse] = useState(null);
  const [selectEvaluation, setSelectEvaluation] = useState(null);
  const [selectReason, setSelectReason] = useState(null);
  const [sendRegister, setSendRegister] = useState(false);
  const [comentary, setComentary] = useState('');
  const [error, setError] = useState(true);
  const [files, setFiles] = useState<any>([]);
  const [teacherRestriction, setTeacherRestriction] = useState(false);
  const { currentPeriod } = useExternalSettings();
  const { procedure: procedureInfo } = useSelector(
    (state: any) => state.procedureInformation
  );
  const { data: typeEvaluation, isLoading: isLoadingEvaluation } = useSelector(
    (state: any) => state.getEvaluationsToBeCorrected
  );
  const { isLoading: isProcessingRegister, data: requestId } = useSelector(
    (state: any) => state.RegisterRectificationOfGrade
  );

  const getSelectedRequest = (url: string): Request | undefined =>
    constants.categories.requests.procedureList.find(
      (p: Request) => p.url === url
    );

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!procedureInfo) {
      const selectedRequest = getSelectedRequest(params);
      const procedureId =
        selectedRequest?.procedureId ??
        constants.categories.requests.procedures.rectificationNotes;
      if (procedureId) {
        dispatch(procedureActions.getProcedureInformation(procedureId));
      }
    }
  }, []);

  useEffect(() => {
    if (selectCourse) {
      const variablesCourse =
        procedureInfo.detail.coursesToRectification.filter(
          (val: any) => val.catalog === selectCourse
        );
      dispatch(
        RectificationsActions.getEvaluationsToBeCorrected(
          `${variablesCourse[0].section}`,
          `${variablesCourse[0].catalog}`
        )
      );
    }
  }, [selectCourse]);

  useEffect(() => {
    setOpenBack(false);
    setSelectCourse(null);
    setSelectEvaluation(null);
    setSelectReason(null);
    setComentary('');
    setFiles([]);
    return () => {
      dispatch(RectificationsActions.getEvaluationsToBeCorrectedClear());
      dispatch(
        RegisterRectificationOfGrade.RegisterRectificationOfGradeClear()
      );
    };
  }, []);

  const handlerBackButton = () => {
    history.goBack();
  };

  const backProcedures = () => {
    history.push('/tramites');
  };

  const SendFiles = async () => {
    const variablesCourse = procedureInfo.detail.coursesToRectification.filter(
      (val: any) => val.catalog === selectCourse
    );
    const note = typeEvaluation.procedures?.evaluationsTobeCorrected.filter(
      (item: any) => item.order === selectEvaluation
    );

    const filesBase64 = await convertFileToBase64(files[0]);

    const register = {
      request: {
        campusCode: variablesCourse[0].campusCode,
        campusName: variablesCourse[0].campusName,
        catalog: variablesCourse[0].catalog,
        module: variablesCourse[0].module,
        courseName: variablesCourse[0].courseName,
        evaluationOrder: `${note[0].order}`,
        evaluationName: note[0].evaluationName,
        section: variablesCourse[0].section,
        period: currentPeriod,
        career: variablesCourse[0].career,
        grade: note[0].grade,
        reasonId: 2,
        commentary: comentary,
        fileName: files[0]?.name,
        fileBase64: filesBase64
      }
    };
    dispatch(
      RegisterRectificationOfGrade.RegisterRectificationOfGrade(register)
    );
  };

  useEffect(() => {
    if (requestId?.registerRectificationOfGrade?.requestId > 0) {
      setSendRegister(true);
    }
  }, [requestId]);

  useEffect(() => {
    const note = typeEvaluation?.procedures?.evaluationsTobeCorrected.filter(
      (item: any) => item.order === selectEvaluation
    );
    if (note && note[0]?.rectificationTeacher === true) {
      setTeacherRestriction(true);
    } else {
      setTeacherRestriction(false);
    }
  }, [selectEvaluation]);

  return (
    <RectificationRegisterView
      procedureInfo={procedureInfo}
      typeEvaluation={typeEvaluation}
      isLoadingEvaluation={isLoadingEvaluation}
      sendRegister={sendRegister}
      backProcedures={backProcedures}
      open={{
        openBack,
        setOpenBack
      }}
      course={{
        selectCourse,
        setSelectCourse
      }}
      reason={{
        selectReason,
        setSelectReason
      }}
      comment={{
        comentary,
        setComentary
      }}
      file={{
        files,
        setFiles
      }}
      evaluation={{
        selectEvaluation,
        setSelectEvaluation
      }}
      teacherEvaluation={{
        teacherRestriction,
        setTeacherRestriction
      }}
      SendFiles={SendFiles}
      isProcessingRegister={isProcessingRegister}
      handlerBackButton={handlerBackButton}
      fileError={{ error, setError }}
    />
  );
};

export default RectificationRegisterViewController;
